import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CopyIcon, ShareIconArrow, SmallShareIcon, } from '@streamr/tv-ui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useShare } from '../hooks/useShare';
import { copyToClipboard } from '../utils/copyToClipboard';
export function CopyUrlButton({ url }) {
    const [copiedAt, setCopiedAt] = useState();
    const [clearCopiedAtAC, setClearCopiedAtAC] = useState();
    useEffect(function abortClearing() {
        return () => {
            clearCopiedAtAC?.abort();
        };
    }, [clearCopiedAtAC]);
    return (_jsxs(ShareButton, { type: "button", onClick: () => {
            copyToClipboard(url, {
                onDone: () => {
                    const ac = new AbortController();
                    setClearCopiedAtAC(ac);
                    setCopiedAt(Date.now());
                    const { signal } = ac;
                    setTimeout(() => {
                        if (!signal.aborted) {
                            setCopiedAt(undefined);
                        }
                    }, 2000);
                },
            });
        }, children: [_jsx(CopyIcon, {}), _jsx("div", { children: copiedAt ? 'Copied!' : 'Copy link' })] }));
}
export function ShareUrlButton({ url }) {
    const { canShare, openSystemShareDialog } = useShare();
    if (!canShare) {
        return null;
    }
    return (_jsxs(ShareButton, { type: "button", onClick: () => {
            openSystemShareDialog(url);
        }, children: [_jsx(SmallShareIcon, {}), _jsx("div", { children: "Share link" })] }));
}
const ShareButton = styled.button `
    align-items: center;
    appearance: none;
    background: rgba(0, 0, 0, 0.1);
    font-weight: 500;
    font-size: 0.875rem;
    border: 0;
    gap: 0.5rem;
    border-radius: 0.375rem;
    height: 2rem;
    display: flex;
    color: #ffffff;
    padding: 0 0.5rem;
`;
export const ShareButtons = styled.div `
    align-items: center;
    display: flex;
    gap: 0.375rem;

    & > * {
        pointer-events: all;
    }
`;
export const ShareButtonRound = ({ url }) => {
    const { canShare, openSystemShareDialog } = useShare();
    if (!canShare) {
        return null;
    }
    return (_jsx(RoundButton, { type: "button", onClick: () => {
            openSystemShareDialog(url);
        }, children: _jsx(ShareIconArrow, { size: "x1_25" }) }));
};
const RoundButton = styled(Button) `
    height: 2.75rem;
    width: 2.75rem;
    --Button_Background: var(--tv-ui-color-12);
    --Button_HoverBackground: var(--tv-ui-color-12);
    --Button_TextColor: var(--tv-ui-color-3);
    --Button_Padding: 0 1rem;
    backdrop-filter: blur(10px);
    transform-origin: center;
    border-radius: 1.5rem;
    will-change: transform;
`;
